// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"e4a2c7b1","142":"a45f025c","218":"d311a49f","276":"9b8aa14b","313":"825f499f","404":"aadcb848","425":"a2cad960","438":"02a169a1","453":"4449bb0e","455":"d473405f","480":"6cf6fe46","664":"43c278c8","778":"022bff52","832":"62881d63","977":"2b21d09d"}[chunkId] + ".chunk.js";
};